import Marquee from "react-fast-marquee";

const TopbannerItems = [
  "Free EU Shipping on Orders Over €120",
  "2-Year Warranty Included",
  "Watch How It Works",
  "Award-Winning Universal Wheel System",
  "Official GuniWheel™ Europe Store",
];

export default function TopBanner() {
  return (
    <div className="bg-black text-white min-h-[30px] lg:px-10 py-1 flex items-center">

      {/* Mobile — marquee */}
      <div className="lg:hidden w-full">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {TopbannerItems.map((item, index) => (
            <span key={item} className="font-roboto font-bold text-[10px] leading-[17px] whitespace-nowrap mx-4">
              {item}
              {index < TopbannerItems.length - 1 && (
                <span className="ml-4 w-1 h-1 rounded-full bg-white inline-block align-middle" />
              )}
            </span>
          ))}
        </Marquee>
      </div>

      {/* Desktop — original static */}
      <div className="hidden lg:flex w-full items-center justify-between gap-2">
        {TopbannerItems.map((item, index) => (
          <div key={item} className="flex items-center gap-2">
            <span className="font-roboto font-bold text-[11px] leading-[17px] whitespace-nowrap">
              {item}
            </span>
            {index < TopbannerItems.length - 1 && (
              <span className="w-1.5 h-1.5 rounded-full bg-white" />
            )}
          </div>
        ))}
      </div>

    </div>
  );
}